import { createSlice } from "@reduxjs/toolkit";
import { GET_USER_INFO_URL } from "../constant";
import axios from "axios";

export const TOKEN = "token";

const getTokenFromStorage = () => {
  try {
    const storedToken = localStorage.getItem(TOKEN);
    if (!storedToken) return "";
    return JSON.parse(storedToken);
  } catch (e) {
    return localStorage.getItem(TOKEN) || "";
  }
};

const initialToken = getTokenFromStorage();

export const userSlice = createSlice({
  name: "user",

  initialState: {
    user: {},
    auth: !!initialToken,
    isAdmin: false,
    token: initialToken,
    // true while we're checking auth on startup — prevents premature redirects
    initializing: !!initialToken,
  },

  reducers: {
    updateUserInfo: (state, { payload }) => {
      state.user = payload;
      state.auth = true;
      state.isAdmin = payload.isAdmin || false;
      state.initializing = false;
      localStorage.setItem("user", JSON.stringify(payload));
    },
    changeToken: (state, { payload: { token } }) => {
      state.token = token;
      state.auth = true;
      localStorage.setItem(TOKEN, JSON.stringify(token));
    },
    clearUser: (state) => {
      state.user = {};
      state.auth = false;
      state.isAdmin = false;
      state.token = "";
      state.initializing = false;
      localStorage.removeItem(TOKEN);
      localStorage.removeItem("user");
    },
    setInitializing: (state, { payload }) => {
      state.initializing = payload;
    },
  },
});

export const { updateUserInfo, changeToken, clearUser, setInitializing } =
  userSlice.actions;

export const getUserInfo = (token) => async (dispatch, getState) => {
  const currentToken = token || getState().user.token;

  if (!currentToken) {
    dispatch(setInitializing(false));
    return;
  }

  try {
    const { data } = await axios.get(GET_USER_INFO_URL, {
      headers: {
        "x-auth-token": currentToken,
      },
    });

    dispatch(updateUserInfo(data));
  } catch (error) {
    console.error("User Info Error:", error);

    // Token expired or invalid — log out
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      dispatch(clearUser());
    } else {
      // Network error or other — stop initializing so app doesn't hang
      dispatch(setInitializing(false));
    }
  }
};

export default userSlice.reducer;
